<template>
    <div>
        <b-table
            :data="records"
            :striped="true"
            :loading="loading"
            :mobile-cards="true"

            backend-pagination
            :total="total"
            :per-page="1000"
            backend-sorting
            :default-sort-direction="sortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"

            :paginated="false"
            :sort-icon="'chevron-up'"
        >
            <template>
                <b-table-column v-slot="props" field="organisation" label="Org." width="50" v-if="user && user.role == 'pit'" class="admin">
                    <strong v-if="props.row.organisation">
                        {{ organisations[props.row.organisation].short_name }}
                    </strong>
                    <span v-else>Basis</span>
                </b-table-column>

                <b-table-column v-slot="props" field="type" label="Type" sortable>
                    {{ props.row.type == 'email' ? 'E-mail' : props.row.type }}
                </b-table-column>

                <b-table-column v-slot="props" field="name" label="Naam" sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column v-slot="props" label="Titel">
                    {{ props.row.title ? props.row.title : '-' }}
                </b-table-column>

                <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="180" sortable>
                    {{ props.row.updated_at|humanDate }}
                </b-table-column>

                <b-table-column v-slot="props" numeric width="100">
                    <div class="invoice-options-dropdown">
                        <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'CommunicationRecord', params: { id: props.row.id }}">Bekijken</b-button>
                        <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" class="is-inline-block">
                            <template #trigger>
                                <b-button
                                    type="is-dark"
                                    size="is-small"
                                    icon-right="chevron-down" />
                            </template>
                            <b-dropdown-item :disabled="_.isNull(props.row.organisation)" aria-role="listitem" @click="promptDelete(props.row.id)">Verwijderen</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0" v-if="loading === false">Geen communicaties gevonden.</p>
                        <p class="margin0" v-else>Laden...</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'CommunicationTable',

    mixins: [filtersMixin, paramsMixin],

    props: {
        name: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        organisations: {
            type: Object,
            required: false
        },
    tableType: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            loading: false,
            records: [],
            total: null,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20,
            searchParams: _.has(this.$store.state.searchQueries, this.name) ? this.$store.state.searchQueries[this.name] : null,
            deleteRecordId: null
        }
    },

    methods: {
        load(){
            this.getSearchParams().then(() => {
                this.loadAsyncData()
            })
        },

        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, this.name)

            this.loading = true
            this.$emit('passLoading', true)

            axios.get(`/api/communications${params ? '?'+params : ''}${this.tableType == 'admin' ? '&admin=true' : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(this.user.role == 'pit'){
                    this.records = _.merge(response.data['base'], response.data['personal'])
                } else {
                    let counter = 0
                    if(response.data['personal'].length){
                        // Replace all base with personal's
                        _.forEach(response.data['personal'], (personal) => {
                            let baseKey = _.findKey(response.data['base'], function(x){ return x.identifier == personal.identifier })
                            response.data['base'][baseKey] = personal

                            if(response.data['personal'].length === ++counter){
                                this.records = response.data['base']
                            }
                        })
                    } else {
                        this.records = response.data['base']
                    }
                }

                this.$store.dispatch('setSearchQuery', {type: this.name, query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching communications:', error)
            }).then(() => {
                this.loading = false
                this.total = this.records ? Object.keys(this.records).length : null

                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        promptDelete(id) {
            this.deleteRecordId = id

            this.$buefy.dialog.confirm({
                title: 'Verwijderen',
                message: 'Weet je zeker dat je deze communicatie wilt verwijderen? De standaard communicatie zal weer worden gebruikt.',
                confirmText: 'Ja, verwijderen',
                cancelText: 'Annuleren',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    this.deleteRecord(id)
                }
            })
        },

        deleteRecord(id) {
            this.loading = true
            this.$emit('passLoading', true)

            axios.delete(`/api/communication/${id}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.load()
                this.$buefy.toast.open({message: 'Communicatie verwijderd!', type: 'is-success'})
            }).catch((error) => {
                this.load()
                console.error('[❌] Error while deleting communication:', error)
                this.$buefy.toast.open({message: 'Er is iets misgegaan!', type: 'is-danger'})
            }).then(() => {
                this.deleteRecordId = null
                this.loading = false

                this.$emit('passLoading', false)
            })
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.load()
        }
    }
}
</script>

<style>
    .table-wrapper{
        padding-bottom: 50px;
    }
</style>